
function bglDrawRoom(el, L, W, fi) {
  if (!el) return;
  var D = [[12, 8], [16, 10], [20, 12], [24, 14]];
  var demo = !(L > 0 && W > 0);
  if (demo) { L = 22; W = 16; }
  if (W > L) { var t = L; L = W; W = t; }
  var rl = D[fi][0], rw = D[fi][1], H = 2, KP = 0.45, WALL = 8;
  var fits = rl + 2 <= L && rw + 2 <= W;
  var C = 0.866, S = 0.5;
  function P(x, y, z) { return [(x - y) * C, (x + y) * S - z]; }
  var pts = [P(0, 0, WALL), P(L, 0, 0), P(0, W, 0), P(L, W, 0), P(L, 0, WALL), P(0, W, WALL)];
  var minX = 1e9, maxX = -1e9, minY = 1e9, maxY = -1e9;
  pts.forEach(function (p) { minX = Math.min(minX, p[0]); maxX = Math.max(maxX, p[0]); minY = Math.min(minY, p[1]); maxY = Math.max(maxY, p[1]); });
  var VW = 900, VH = 560, pad = 40;
  var k = Math.min((VW - 2 * pad) / (maxX - minX), (VH - 2 * pad) / (maxY - minY));
  var ox = pad - minX * k + ((VW - 2 * pad) - (maxX - minX) * k) / 2, oy = pad - minY * k + ((VH - 2 * pad) - (maxY - minY) * k) / 2;
  function Q(x, y, z) { var p = P(x, y, z); return (ox + p[0] * k).toFixed(1) + ',' + (oy + p[1] * k).toFixed(1); }
  function poly(a, fill, stroke, sw) { return '<polygon points="' + a.join(' ') + '" fill="' + fill + '"' + (stroke ? ' stroke="' + stroke + '" stroke-width="' + (sw || 1) + '" stroke-linejoin="round"' : '') + '/>'; }
  function txt(x, y, z, s, size, col, anchor) { var p = Q(x, y, z).split(','); var at = ' x="' + p[0] + '" y="' + p[1] + '" font-family="Archivo, Helvetica, sans-serif" font-weight="800" font-size="' + size + '" text-anchor="' + (anchor || 'middle') + '"'; return '<text' + at + ' fill="none" stroke="#161616" stroke-width="5" stroke-linejoin="round">' + s + '</text><text' + at + ' fill="' + col + '">' + s + '</text>'; }
  var o = '';
  o += poly([Q(0, 0, 0), Q(L, 0, 0), Q(L, 0, WALL), Q(0, 0, WALL)], '#ECE8E2', '#D6D1C8');
  o += poly([Q(0, 0, 0), Q(0, W, 0), Q(0, W, WALL), Q(0, 0, WALL)], '#DDD8CF', '#D6D1C8');
  o += poly([Q(0, 0, 0), Q(L, 0, 0), Q(L, W, 0), Q(0, W, 0)], '#C49A6C', '#A97F52');
  for (var i = 1; i < L; i += 1) o += '<line x1="' + Q(i, 0, 0).split(',')[0] + '" y1="' + Q(i, 0, 0).split(',')[1] + '" x2="' + Q(i, W, 0).split(',')[0] + '" y2="' + Q(i, W, 0).split(',')[1] + '" stroke="#B88D60" stroke-width="1"/>';
  var x0 = (L - rl) / 2, y0 = (W - rw) / 2, r = Math.min(2.5, rw / 3.2), ring = [];
  var cs = [[x0 + rl - r, y0 + r, -90], [x0 + rl - r, y0 + rw - r, 0], [x0 + r, y0 + rw - r, 90], [x0 + r, y0 + r, 180]];
  cs.forEach(function (c) { for (var j = 0; j <= 6; j++) { var a = (c[2] + j * 15) * Math.PI / 180; ring.push([c[0] + r * Math.cos(a), c[1] + r * Math.sin(a)]); } });
  o += poly(ring.map(function (p) { return Q(p[0], p[1], 0); }), '#F8FBFD', '#DCE6EE');
  o += '<line x1="' + Q(x0 + rl / 2, y0, 0).split(',')[0] + '" y1="' + Q(x0 + rl / 2, y0, 0).split(',')[1] + '" x2="' + Q(x0 + rl / 2, y0 + rw, 0).split(',')[0] + '" y2="' + Q(x0 + rl / 2, y0 + rw, 0).split(',')[1] + '" stroke="#E01B22" stroke-width="' + (k * 0.18).toFixed(1) + '" opacity="0.8"/>';
  [rl / 3, 2 * rl / 3].forEach(function (d) { o += '<line x1="' + Q(x0 + d, y0, 0).split(',')[0] + '" y1="' + Q(x0 + d, y0, 0).split(',')[1] + '" x2="' + Q(x0 + d, y0 + rw, 0).split(',')[0] + '" y2="' + Q(x0 + d, y0 + rw, 0).split(',')[1] + '" stroke="#2F6FD6" stroke-width="' + (k * 0.15).toFixed(1) + '" opacity="0.75"/>'; });
  var segs = [];
  for (var m = 0; m < ring.length; m++) {
    var a = ring[m], b = ring[(m + 1) % ring.length];
    var nx = b[1] - a[1], ny = -(b[0] - a[0]);
    segs.push({ a: a, b: b, d: (a[0] + b[0] + a[1] + b[1]) / 2, near: (nx + ny) > 0 });
  }
  segs.sort(function (p, q) { return p.d - q.d; });
  var rail = (k * 0.3).toFixed(1);
  segs.forEach(function (sg) {
    var a = sg.a, b = sg.b;
    if (sg.near) {
      o += poly([Q(a[0], a[1], 0), Q(b[0], b[1], 0), Q(b[0], b[1], H), Q(a[0], a[1], H)], '#E3E7EB', '#C3CAD1', 0.6);
    } else {
      o += poly([Q(a[0], a[1], 0), Q(b[0], b[1], 0), Q(b[0], b[1], KP), Q(a[0], a[1], KP)], '#F2B400');
      o += poly([Q(a[0], a[1], KP), Q(b[0], b[1], KP), Q(b[0], b[1], H), Q(a[0], a[1], H)], '#FFFFFF', '#E8ECEF', 0.6);
    }
    o += '<line x1="' + Q(a[0], a[1], H).split(',')[0] + '" y1="' + Q(a[0], a[1], H).split(',')[1] + '" x2="' + Q(b[0], b[1], H).split(',')[0] + '" y2="' + Q(b[0], b[1], H).split(',')[1] + '" stroke="' + (fits ? '#E01B22' : '#7A0A0E') + '" stroke-width="' + rail + '" stroke-linecap="round"/>';
  });
  var px = Math.min(L - 1, x0 + rl + 1.2), py = Math.min(W - 1, y0 + rw + 0.6);
  if (px > x0 + rl + 0.5 || py > y0 + rw + 0.5) {
    var base = Q(px, py, 0).split(','), top = Q(px, py, 5.8).split(',');
    var bx = +base[0], by = +base[1], ty = +top[1], hw = k * 0.55;
    o += '<rect x="' + (bx - hw).toFixed(1) + '" y="' + (ty + k * 1.1).toFixed(1) + '" width="' + (2 * hw).toFixed(1) + '" height="' + (by - ty - k * 1.1).toFixed(1) + '" rx="' + (hw * 0.8).toFixed(1) + '" fill="#2A2A2A"/>';
    o += '<circle cx="' + bx + '" cy="' + (ty + k * 0.55).toFixed(1) + '" r="' + (k * 0.5).toFixed(1) + '" fill="#2A2A2A"/>';
    o += txt(px, py, -1.2, '5 pi 10', Math.max(12, k * 0.55).toFixed(0), '#D9D9D9');
  }
  var fs = Math.max(13, Math.min(22, k * 0.9)).toFixed(0);
  o += txt(L / 2, W + 1.8, 0, 'Pièce : ' + (Math.round(L * 10) / 10) + ' pi', fs, '#FFFFFF');
  o += txt(L + 1.6, W / 2, 0, (Math.round(W * 10) / 10) + ' pi', fs, '#FFFFFF', 'start');
  o += txt(x0 + rl / 2, y0 + rw / 2, H + 3.2, ['La recrue','La relève','La pro','La grande ligue'][fi] + ' · ' + rw + ' x ' + rl + ' pi', fs, fits ? '#FFFFFF' : '#FF5A5F');
  function banner(t, col) { return '<text x="' + VW / 2 + '" y="26" font-family="Archivo, Helvetica, sans-serif" font-weight="800" font-size="18" fill="' + col + '" text-anchor="middle">' + t + '</text>'; }
  if (!fits) o += banner('Ce format n\u2019entre pas : il faut 1 pi de dégagement tout le tour', '#FF5A5F');
  else if (demo) o += banner('Exemple : pièce de 22 x 16 pi. Entrez vos mesures ci-dessus.', '#A6A6A6');
  el.innerHTML = '<svg viewBox="0 0 ' + VW + ' ' + VH + '" role="img" aria-label="Vue 3D : mini-rink ' + rw + ' x ' + rl + ' pi dans une pièce de ' + Math.round(L) + ' x ' + Math.round(W) + ' pi" style="display:block;width:100%;height:auto">' + o + '</svg>';
}



(function(){
// Nerd 2026-10-30 : le site n'est plus une page unique. Chaque page Shopify (/pages/...) ne contient qu'une section : on l'affiche et on lance sa vidéo.
var page = document.querySelector('.page');
if (page) { page.hidden = false; page.querySelectorAll('video').forEach(function(v){ try { v.play(); } catch(e) {} }); }
// Lien avec ancre (/pages/realisations#arenas) : on descend à la section une fois la page chargée
if (location.hash.length > 1) {
  window.addEventListener('load', function(){
    var t = document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (t && Math.abs(t.getBoundingClientRect().top) > 150) t.scrollIntoView({ behavior: 'instant' });
  });
}
// Mini-rink
var prix=['1\u00a0999\u00a0$','2\u00a0499\u00a0$','2\u00a0999\u00a0$','3\u00a0499\u00a0$'];
var sel={fmt:0,surf:0,inst:0};
var PF=[1999,2499,2999,3499], PL=[0,100,200,300], PAN=[16,30,40,56], TUI=[96,160,240,336];
function money(n){n=Math.round(n*100)/100;return n.toLocaleString('fr-CA', n%1===0?{}:{minimumFractionDigits:2,maximumFractionDigits:2})+String.fromCharCode(160)+'$';}
function paint(){document.querySelectorAll('.opt').forEach(function(b){b.setAttribute('aria-pressed', String(sel[b.dataset.g]===+b.dataset.i));}); var CS=[0,Math.round(PAN[sel.fmt]*44.99*100)/100,TUI[sel.fmt]*3.5]; var sb=document.querySelectorAll('.opt[data-g="surf"]'); if(sb.length===3){ sb[1].lastElementChild.textContent=PAN[sel.fmt]+' panneaux 3 x 2 pi, '+money(CS[1]); sb[2].lastElementChild.textContent=TUI[sel.fmt]+' tuiles 12 x 12 po, '+money(CS[2]); } var p=document.getElementById('prix'); if(p) p.textContent=money(PF[sel.fmt]+CS[sel.surf]+PL[sel.inst]);}
document.querySelectorAll('.opt').forEach(function(b){b.addEventListener('click',function(){sel[b.dataset.g]=+b.dataset.i; paint();});}); paint();
document.querySelectorAll('.pic').forEach(function(b){b.addEventListener('click',function(){var img=b.querySelector('img'); var ph=document.getElementById('photo'); ph.src=img.src; ph.alt=b.getAttribute('aria-label'); document.querySelectorAll('.pic').forEach(function(x){x.style.borderColor=x===b?'#E01B22':'transparent';});});});
var L=document.getElementById('long'), W=document.getElementById('larg');
var calc=function(){var l=parseFloat(L.value), w=parseFloat(W.value), r=document.getElementById('res'), n=document.getElementById('resNote');
  if(!(l>0&&w>0)){r.textContent='\u2014'; n.textContent='Entrez la longueur et la largeur de votre espace.'; return;}
  var a=Math.max(l,w)-2, c=Math.min(l,w)-2;
  if(a<=0||c<=0){r.textContent='Trop petit'; n.textContent='Cet espace est trop petit pour un mini-rink.'; return;}
  var D=[[12,8],[16,10],[20,12],[24,14]], N = ['La recrue · 8 x 12 pi','La relève · 10 x 16 pi','La pro · 12 x 20 pi','La grande ligue · 14 x 24 pi'], best=-1; D.forEach(function(d,i){ if(d[0]<=a&&d[1]<=c) best=i; });
  var u=(Math.floor(a*10)/10)+' x '+(Math.floor(c*10)/10)+' pi', lab=document.getElementById('resLab');
  if(best>=0){ r.textContent=N[best]; lab.textContent='Le plus grand format qui entre chez vous'; n.textContent='Espace utile : '+u+', avec le dégagement pour monter les bandes.'; sel.fmt=best; paint(); }
  else { r.textContent='Sur mesure'; lab.textContent='Aucun format standard n\u2019entre'; n.textContent='Votre espace utile est de '+u+'. On peut fabriquer un mini-rink sur mesure : demandez une soumission.'; }}
if(L&&W){L.addEventListener('input',calc); W.addEventListener('input',calc);}
var view=0;
function drawView(){ var el=document.getElementById('viz'); if(!el) return; bglDrawRoom(el, parseFloat(L.value), parseFloat(W.value), view);
  document.querySelectorAll('.vfb').forEach(function(b){ var on=+b.dataset.i===view; b.setAttribute('aria-pressed',String(on)); b.style.background=on?'#E01B22':'transparent'; b.style.borderColor=on?'#E01B22':'#3A3A3A'; }); }
document.querySelectorAll('.vfb').forEach(function(b){ b.addEventListener('click',function(){ view=+b.dataset.i; drawView(); }); });
var _calc=calc; calc=function(){ _calc(); var r=document.getElementById('res').textContent; var N = ['La recrue · 8 x 12 pi','La relève · 10 x 16 pi','La pro · 12 x 20 pi','La grande ligue · 14 x 24 pi']; var i=N.indexOf(r); view = i>=0 ? i : 0; drawView(); };
if(L&&W){ L.removeEventListener('input',_calc); W.removeEventListener('input',_calc); L.addEventListener('input',calc); W.addEventListener('input',calc); }
drawView();

// Panier Shopify : le mini-rink est le produit « mini-rink » (options Format, Surface, Livraison)
var FMT=['8 x 12 pi','10 x 16 pi','12 x 20 pi','14 x 24 pi'], SURF=['Bandes seulement','Glace synthétique','Tuiles de dek'], LIV=["Ramassage à Victoriaville","Jusqu'à 100 km","100 à 200 km","200 à 300 km"];
var btn=document.getElementById('ajout-panier');
if(btn){btn.addEventListener('click',function(){var lab=btn.textContent;btn.disabled=true;btn.textContent='Ajout au panier…';
  fetch('/products/mini-rink.js').then(function(r){if(!r.ok)throw 0;return r.json();}).then(function(p){
    var want=[FMT[sel.fmt],SURF[sel.surf],LIV[sel.inst]].join('|');
    var v=p.variants.filter(function(x){return x.options.join('|')===want;})[0]; if(!v||!v.available)throw 0;
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]})});
  }).then(function(r){if(!r.ok)throw 0;location.href='/cart';})
  .catch(function(){btn.disabled=false;btn.textContent='Oups, réessayez ou appelez-nous au 514 358-3306';setTimeout(function(){btn.textContent=lab;},5000);});});}

})();

/* Nerd 2026-10-30 : menu hamburger sur mobile (moins de 900 px) */
(function(){
  var MQ = window.matchMedia('(max-width: 900px)');
  // Ouvre ou ferme une liste (Produits, Services) en animant sa hauteur
  function setSub(dd, open){
    var m = dd.querySelector('.menu'), a = dd.querySelector(':scope > a');
    dd.classList.toggle('bgl-sub-open', open);
    if (a) a.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (m) m.style.maxHeight = open ? (m.scrollHeight + 24) + 'px' : '';
  }
  function closeAll(except){
    document.querySelectorAll('header.bgl-open').forEach(function(h){ if (h === except) return; h.classList.remove('bgl-open'); var b = h.querySelector('.bgl-burger'); if (b) b.setAttribute('aria-expanded', 'false'); });
    document.querySelectorAll('.dd.bgl-sub-open').forEach(function(d){ if (!except || !except.contains(d)) setSub(d, false); });
    document.documentElement.classList.toggle('bgl-menu-open', !!document.querySelector('header.bgl-open'));
  }
  document.querySelectorAll('.page header').forEach(function(h, i){
    var bar = h.firstElementChild, nav = h.querySelector('nav');
    if (!bar || !nav || h.querySelector('.bgl-burger')) return;
    nav.id = nav.id || 'bgl-nav-' + i;
    var badge = nav.querySelector('a[href="/pages/mini-rink"][aria-label]');
    if (badge) { var c = badge.cloneNode(true); c.classList.add('bgl-bar-badge'); nav.parentNode.insertBefore(c, nav); }
    var cta = bar.querySelector(':scope > a[href="/pages/contact"]');
    if (cta) { var c2 = cta.cloneNode(true); c2.classList.add('bgl-nav-cta'); nav.appendChild(c2); }
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'bgl-burger';
    btn.setAttribute('aria-controls', nav.id); btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-label', 'Menu');
    btn.innerHTML = '<span></span><span></span><span></span>';
    bar.appendChild(btn);
    btn.addEventListener('click', function(){
      var open = !h.classList.contains('bgl-open');
      closeAll(h);
      h.classList.toggle('bgl-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('bgl-menu-open', open);
    });
  });
  // Sur mobile, Produits et Services ouvrent leur liste au lieu de changer de page
  document.addEventListener('click', function(e){
    if (!MQ.matches) return;
    var a = e.target.closest('.dd > a');
    if (a && a.closest('header.bgl-open')) {
      e.preventDefault(); e.stopPropagation();
      var dd = a.parentNode, open = !dd.classList.contains('bgl-sub-open');
      dd.parentNode.querySelectorAll('.dd.bgl-sub-open').forEach(function(d){ if (d !== dd) setSub(d, false); });
      setSub(dd, open);
      return;
    }
    if (e.target.closest('header.bgl-open nav a, header.bgl-open .bgl-bar-badge, header.bgl-open > div > a')) closeAll();
  }, true);
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeAll(); });
  window.addEventListener('popstate', function(){ closeAll(); });
  (MQ.addEventListener ? MQ.addEventListener('change', function(){ closeAll(); }) : MQ.addListener(function(){ closeAll(); }));
})();

/* Nerd 2026-10-30 : barre du haut fixe sur mobile, fond noir dès qu'on défile */
(function(){
  function onScroll(){ document.documentElement.classList.toggle('bgl-scrolled', window.scrollY > 10); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* Nerd 2026-10-30 : fondu entre les pages (la classe n'est posée qu'au premier changement de page) */
(function(){
  function arm(){ document.documentElement.classList.add('bgl-nav'); }
  document.addEventListener('click', function(e){
    var a = e.target.closest && e.target.closest('a[href]');
    if (a && /^[A-Za-z0-9]+\.dc\.html/.test(a.getAttribute('href') || '')) arm();
  }, true);
  window.addEventListener('popstate', arm);
})();

/* Nerd 2026-10-30 : apparition en fondu au défilement (titres, intros, sous-titres et photos sous le premier écran) */
(function(){
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = 'h2, h2 + p, img, h3';
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) { e.target.classList.add('bgl-in'); io.unobserve(e.target); }
    });
  // La marge du haut est immense : un élément qu'on a dépassé d'un coup (défilement rapide, ancre) apparaît aussi
  }, { rootMargin: '200000px 0px -6% 0px', threshold: 0 });
  function prep(page){
    if (!page || page.hidden || page.getAttribute('data-bgl-fx')) return;
    page.setAttribute('data-bgl-fx', '1');
    var vh = window.innerHeight;
    page.querySelectorAll('section').forEach(function(s){
      if (s.querySelector(':scope > header')) return;
      s.querySelectorAll(SEL).forEach(function(el){
        if (el.parentElement.closest('.bgl-reveal')) return;
        if (el.closest('[style*="position: sticky"], form, .menu, .opt, .pic, button')) return;
        if (/transform/.test(el.getAttribute('style') || '')) return;
        var r = el.getBoundingClientRect();
        if (!r.height || r.top < vh) return;
        if (el.tagName === 'IMG' && r.width < 120) return;
        var g = el.closest('[style*="display: grid"] > *');
        if (g) el.style.transitionDelay = (Math.min(Array.prototype.indexOf.call(g.parentElement.children, g), 3) * 80) + 'ms';
        el.classList.add('bgl-reveal');
        io.observe(el);
      });
    });
  }
  function current(){ return document.querySelector('.page:not([hidden])'); }
  prep(current());
  new MutationObserver(function(){ setTimeout(function(){ prep(current()); }, 0); })
    .observe(document.body, { subtree: true, attributes: true, attributeFilter: ['hidden'] });
})();

/* Nerd 2026-10-30 : boutons du tableau comparatif et des surfaces : choisissent l'option dans le configurateur puis y descendent (#acheter) */
document.addEventListener('click', function(e){
  var a = e.target.closest && e.target.closest('a[data-bgl-fmt], a[data-bgl-surf]');
  if (!a) return;
  var g = a.hasAttribute('data-bgl-fmt') ? 'fmt' : 'surf', i = a.getAttribute('data-bgl-' + g);
  var opt = document.querySelector('.page:not([hidden]) .opt[data-g="' + g + '"][data-i="' + i + '"]');
  if (opt) opt.click();
}, true);
